import { createFileRoute } from '@tanstack/react-router'
import { Dashboard } from '@/components/dashboard/dashboard'
import { requireAuth } from '@/lib/route-guards'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: requireAuth,
  component: Dashboard,
  head: () => ({
    meta: [
      { title: 'Dashboard — mkdn.app' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
})
